export default __webpack_public_path__ + "static/media/11.cbc4b4ac.jpeg";